export default {
  mobile: "@media screen and (max-width: 767px)",
  hackTable: "@media screen and (min-width: 700px)",
  tablet: "@media screen and (min-width: 768px)",
  desktop: "@media screen and (min-width: 1024px)"
};



// WEBPACK FOOTER //
// ./src/styles/media-queries.js